import { atom } from "recoil";
import { ocPersistAtom } from "./persist-atom";

export const ocNarrowMenuState = atom({
  key: "ocNarrowMenuState",
  default: false,
  effects_UNSTABLE: [ocPersistAtom],
});
